import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { verifyOtp } from "../lib/api";

export default function VerifyOtp() {
  const location = useLocation();
  const navigate = useNavigate();
  const inputRef = useRef(null);

  const pendingToken = location.state?.pendingToken;
  const phoneMasked = location.state?.phoneMasked || "+33 *** *** ***";
  const smsSent = location.state?.smsSent ?? true;

  const [code, setCode] = useState("");
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!pendingToken) {
      navigate("/", { replace: true });
    }
    inputRef.current?.focus();
  }, [pendingToken, navigate]);

  const submit = async (e) => {
    e?.preventDefault();
    if (code.length !== 6) return;
    setSubmitting(true);
    setError(null);
    try {
      await verifyOtp(pendingToken, code);
      navigate("/dashboard", { replace: true });
    } catch (err) {
      const msg = err?.response?.data?.detail || "Code invalide";
      setError(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <div className="strip flex items-center justify-between">
        <span>Vérification par SMS</span>
        <span>Authentification</span>
      </div>
      <div className="flex-1 flex items-center justify-center px-4">
        <form
          onSubmit={submit}
          className="surface surface-shadow p-8 w-full max-w-md reveal"
          data-testid="otp-card"
        >
          <div className="label border-b-2 border-[var(--ink)] pb-3 mb-6">
            Vérification téléphonique
          </div>
          <h2 className="font-display text-3xl mb-2">Saisir le code</h2>
          <p className="text-[var(--muted)] text-sm mb-1">
            Code à 6 chiffres envoyé par SMS au numéro :
          </p>
          <p className="font-mono text-sm mb-6">{phoneMasked}</p>

          {!smsSent && (
            <div className="border-2 border-[var(--warning)] bg-[var(--warning)] text-[var(--ink)] p-3 mb-4 text-xs font-mono" data-testid="otp-sms-warning">
              ⚠ L'API Free Mobile a refusé l'envoi. Vérifiez FREE_MOBILE_USER / FREE_MOBILE_PASS dans le backend .env.
            </div>
          )}

          <input
            ref={inputRef}
            type="text"
            inputMode="numeric"
            pattern="\d{6}"
            maxLength={6}
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
            className="input input-mono otp-cell border-2 border-[var(--ink)]"
            placeholder="000000"
            data-testid="otp-input"
          />

          {error && (
            <div className="mt-4 border-2 border-[var(--ink)] bg-[var(--accent)] text-white p-3 text-xs font-mono" data-testid="otp-error">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={code.length !== 6 || submitting}
            className="btn btn-primary w-full justify-center mt-6"
            data-testid="otp-submit"
          >
            {submitting ? <span className="spinner" /> : "Valider"}
          </button>

          <button
            type="button"
            className="btn btn-secondary w-full justify-center mt-3"
            onClick={() => navigate("/", { replace: true })}
            data-testid="otp-cancel"
          >
            Annuler
          </button>

          <div className="mt-6 text-xs font-mono text-[var(--muted)]">
            → Code valide 5 minutes · 5 tentatives max.
          </div>
        </form>
      </div>
    </div>
  );
}
